
import axios from 'ps-components/lib/apiClient';
import { useMutation } from 'react-query';
import { useForm } from '@mantine/form';
import { notifications } from '@mantine/notifications'
import { useAppState } from '../redux';

type ChangePasswordPayload = {
  current: string
  new: string
  confirmed: string
}

export const useChangeUserPassword = () => {
  const appState = useAppState()
  const orgCode = appState.session.organization.code
  const validPasswordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*(),.?":{}|<>]).{8,}$/
  const form = useForm({
    mode: 'uncontrolled',
    initialValues: {
      current: '',
      new: '',
      confirmed: ''
    },
    validate: {
      current: value => {
        if (!value.length) return 'Current Password is Required'
        return null
      },
      new: value => {
        if (!value.length) return 'New Password is Required'
        if (!validPasswordRegex.test(value)) return 'Invalid Password'
        return null
      },
      confirmed: (value, values) => {
        if (!value.length) return 'Password Confirmation is Required'
        if (value !== values.new) return 'Password must match'
        return null
      }
    }
  })

  const changeUserPassword = async (payload: ChangePasswordPayload) => {
    const response = await axios.apiPost('/api/generic-user/users/changeUserPassword', payload)
    if (!response.data.success) throw new Error(`${response.data.field}:${response.data.message}` || 'Error Changing Password')
    return response.data
  }

  const mutation = useMutation(changeUserPassword, {
    onError: (err) => {
      const error = err instanceof Error ? err.message : 'Error Changing Password'
      const [field, message] = error.split(':')
      if (field && ['current', 'new', 'confirmed'].includes(field)) {
        form.setFieldError(field, message)
      } else {
        notifications.show({ message, color: 'red' })
      }
    },
    onSuccess: () => {
      window.location.href = `${window.location.origin}/oauth/${orgCode}/login`
    }
  })
  return { ...mutation, form }
}
